import './App.css';
import Sidebar from './Sidebar';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useCookies } from 'react-cookie';
import './Main.css';
import Background from './Background';
import { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { getDisplayFields, FIELD_LABELS, FIELD_INPUT_TYPES } from './serviceFieldConfig';

const API_BASE = 'https://api.connecker.com/api';
const STORAGE_BASE = 'https://api.connecker.com/storage';

function ServiceList() {
    const { serviceTypeId } = useParams();
    const history = useHistory();
    const [cookies] = useCookies(['user']);
    const [services, setServices] = useState([]);
    const [serviceType, setServiceType] = useState(null);
    const [serviceTypes, setServiceTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [editingService, setEditingService] = useState(null);
    const [editForm, setEditForm] = useState({
        service_type_id: '',
        name: '',
        phone: '',
        email: '',
        address: '',
        image: null
    });

    const displayFields = getDisplayFields(serviceType?.allowed_fields);

    const getServices = () => {
        var data = new FormData();
        data.append("service_type_id", serviceTypeId);
        setIsLoading(true);
        fetch(`${API_BASE}/get_services`, {
            method: 'POST',
            body: data
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                setServices(data.data || []);
            } else {
                setServices([]);
            }
        }).catch(() => {
            setIsLoading(false);
            setServices([]);
        });
    };

    const getServiceType = () => {
        var data = new FormData();
        data.append("service_type_id", serviceTypeId);
        fetch(`${API_BASE}/get_service_type`, {
            method: 'POST',
            body: data
        }).then(res => res.json()).then(data => {
            if (data.response_code === 200) {
                setServiceType(data.data);
            }
        }).catch(() => setServiceType(null));
    };

    const getServiceTypes = () => {
        fetch(`${API_BASE}/get_service_types`, { method: 'POST' })
            .then(res => res.json())
            .then(data => {
                if (data.response_code === 200) {
                    setServiceTypes(data.data || []);
                }
            });
    };

    const deleteServiceAPI = (serviceId) => {
        var data = new FormData();
        data.append("service_id", serviceId);
        setIsLoading(true);
        fetch(`${API_BASE}/delete_service`, {
            method: 'POST',
            body: data,
            headers: { 'Authorization': `Bearer ${cookies.token}` }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                getServices();
            } else {
                toast.error(data.message || 'Failed to delete service');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to delete service');
        });
    };

    const deleteService = (serviceId) => {
        if (window.confirm('Are you sure you want to delete this service?')) {
            deleteServiceAPI(serviceId);
        }
    };

    const openEditModal = (service) => {
        setEditingService(service);
        const base = {
            service_type_id: String(service.service_type_id),
            name: service.name || '',
            phone: service.phone || '',
            email: service.email || '',
            address: service.address || '',
            image: null
        };
        const extra = {};
        (getDisplayFields(serviceType?.allowed_fields) || []).forEach(f => {
            if (!['name', 'phone', 'email', 'address', 'image'].includes(f)) {
                extra[f] = service[f] ?? '';
            }
        });
        setEditForm({ ...base, ...extra });
    };

    const closeEditModal = () => {
        setEditingService(null);
        setEditForm({ service_type_id: '', name: '', phone: '', email: '', address: '', image: null });
    };

    const handleEditFormChange = (field, value) => {
        setEditForm(prev => ({ ...prev, [field]: value }));
    };

    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setEditForm(prev => ({ ...prev, image: e.target.files[0] }));
        }
    };

    const editServiceAPI = (e) => {
        e.preventDefault();
        if (!editingService) return;
        var data = new FormData();
        data.append("service_id", String(editingService.id));
        if (editForm.service_type_id) data.append("service_type_id", editForm.service_type_id);
        displayFields.forEach(field => {
            if (field === 'image') {
                if (editForm.image) data.append("image", editForm.image);
            } else if (editForm[field] !== undefined && editForm[field] !== null) {
                data.append(field, String(editForm[field]));
            }
        });
        setIsLoading(true);
        fetch(`${API_BASE}/update_service`, {
            method: 'POST',
            body: data,
            headers: { 'Authorization': `Bearer ${cookies.token}` }
        }).then(res => res.json()).then(data => {
            setIsLoading(false);
            if (data.response_code === 200) {
                toast.success(data.message);
                closeEditModal();
                getServices();
            } else {
                toast.error(data.message || 'Failed to update service');
            }
        }).catch(() => {
            setIsLoading(false);
            toast.error('Failed to update service');
        });
    };

    const getImageUrl = (service) => {
        if (service?.image) return `${STORAGE_BASE}/${service.image}`;
        return null;
    };

    useEffect(() => {
        getServiceType();
        getServiceTypes();
    }, [serviceTypeId]);

    useEffect(() => {
        getServices();
    }, [serviceTypeId]);

    return (
        <div className="content">
            <div className="row justify-content-start">
                <div className="col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2">
                    <Sidebar />
                </div>
                <div className="col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 col-xxl-10" style={{ paddingLeft: "40px" }}>
                    <Background />
                    <div className="d-flex justify-content-between align-items-center" style={{ marginTop: "50px" }}>
                        <div className="d-flex align-items-center gap-3">
                            <button
                                className="btn btn-link text-white p-0"
                                onClick={() => history.push('/services')}
                                style={{ textDecoration: 'none', fontSize: '14px' }}
                            >
                                ← Back to Service Types
                            </button>
                            <h4 className="heading mb-0" style={{ color: "white" }}>
                                {serviceType ? serviceType.name : 'Services'}
                            </h4>
                        </div>
                        <Link to={`/add_service_item/${serviceTypeId}`}>
                            <button
                                className="btn"
                                style={{
                                    backgroundColor: "#FF4500",
                                    color: "white",
                                    border: "1px solid #FF4500",
                                    borderRadius: "25px",
                                    padding: "10px 20px",
                                    fontWeight: "500"
                                }}
                            >
                                Add Service
                            </button>
                        </Link>
                    </div>

                    <div className="card" style={{ borderColor: "white", marginTop: "20px" }}>
                        <div className="table-responsive">
                            <table style={{ width: "100%" }} className="table table-striped">
                                <thead style={{ backgroundColor: "#f8f9fa" }}>
                                    <tr style={{ borderBottom: "2px solid #dee2e6" }}>
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>#</th>
                                        {displayFields.map(field => (
                                            <th key={field} style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>
                                                {(FIELD_LABELS[field] || field).toUpperCase()}
                                            </th>
                                        ))}
                                        <th style={{ color: "#666", fontWeight: "600", fontSize: "14px", padding: "12px 8px" }}>ACTIONS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {isLoading && services.length === 0 ? (
                                        <tr>
                                            <td colSpan={displayFields.length + 2} style={{ padding: "40px", textAlign: "center", color: "#999" }}>
                                                Loading services...
                                            </td>
                                        </tr>
                                    ) : services.length === 0 ? (
                                        <tr>
                                            <td colSpan={displayFields.length + 2} style={{ padding: "40px", textAlign: "center", color: "#999" }}>
                                                No services found. Add one to get started.
                                            </td>
                                        </tr>
                                    ) : (
                                        services.map((service, i) => (
                                            <tr key={service.id} style={{ borderBottom: "1px solid #eee" }}>
                                                <td style={{ padding: "12px 8px", fontSize: "14px", color: "#333" }}>{i + 1}</td>
                                                {displayFields.map(field => (
                                                    <td key={field} style={{ padding: "12px 8px", fontSize: "14px", color: field === 'name' ? "#333" : "#666", fontWeight: field === 'name' ? "500" : "normal", maxWidth: field === 'address' || field === 'raison_sociale_and_addresses' ? "200px" : undefined }}>
                                                        {field === 'image' ? (
                                                            getImageUrl(service) ? (
                                                                <img
                                                                    src={getImageUrl(service)}
                                                                    alt={service.name}
                                                                    style={{ width: "60px", height: "60px", objectFit: "cover", borderRadius: "8px" }}
                                                                />
                                                            ) : (
                                                                <span style={{ color: "#999", fontStyle: "italic" }}>No image</span>
                                                            )
                                                        ) : (
                                                            (() => {
                                                                const val = service[field];
                                                                if (val == null || val === '') return '-';
                                                                const str = String(val);
                                                                return (field === 'address' || field === 'raison_sociale_and_addresses') && str.length > 50
                                                                    ? str.substring(0, 50) + '...'
                                                                    : str;
                                                            })()
                                                        )}
                                                    </td>
                                                ))}
                                                <td style={{ padding: "12px 8px" }}>
                                                    <button
                                                        className="btn btn-sm me-1"
                                                        onClick={() => openEditModal(service)}
                                                        style={{
                                                            backgroundColor: "#0d6efd",
                                                            borderColor: "#0d6efd",
                                                            color: "white",
                                                            fontSize: "12px",
                                                            padding: "6px 12px",
                                                            borderRadius: "6px"
                                                        }}
                                                    >
                                                        Edit
                                                    </button>
                                                    <button
                                                        className="btn btn-sm"
                                                        onClick={() => deleteService(service.id)}
                                                        style={{
                                                            backgroundColor: "#dc3545",
                                                            borderColor: "#dc3545",
                                                            color: "white",
                                                            fontSize: "12px",
                                                            padding: "6px 12px",
                                                            borderRadius: "6px"
                                                        }}
                                                    >
                                                        Delete
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {editingService && (
                <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }} tabIndex="-1">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Edit Service</h5>
                                <button type="button" className="btn-close" onClick={closeEditModal} aria-label="Close"></button>
                            </div>
                            <form onSubmit={editServiceAPI}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Service Type</label>
                                        <select
                                            className="form-select"
                                            value={editForm.service_type_id}
                                            onChange={(e) => handleEditFormChange('service_type_id', e.target.value)}
                                            required
                                        >
                                            <option value="">Select type</option>
                                            {serviceTypes.map(st => (
                                                <option key={st.id} value={st.id}>{st.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    {displayFields.map(field => {
                                        if (field === 'image') {
                                            return (
                                                <div key={field} className="mb-3">
                                                    <label className="form-label">{FIELD_LABELS[field]} (optional - leave empty to keep current)</label>
                                                    <input
                                                        type="file"
                                                        className="form-control"
                                                        accept="image/*"
                                                        onChange={handleImageChange}
                                                    />
                                                    {editForm.image ? (
                                                        <div className="mt-2">
                                                            <img
                                                                src={URL.createObjectURL(editForm.image)}
                                                                alt="Preview"
                                                                style={{ maxWidth: "200px", maxHeight: "150px", borderRadius: "8px" }}
                                                            />
                                                        </div>
                                                    ) : editingService.image && (
                                                        <div className="mt-2">
                                                            <p className="text-muted small">Current image:</p>
                                                            <img
                                                                src={`${STORAGE_BASE}/${editingService.image}`}
                                                                alt="Current"
                                                                style={{ maxWidth: "200px", maxHeight: "150px", borderRadius: "8px" }}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        }
                                        const inputType = FIELD_INPUT_TYPES[field] || 'text';
                                        const isRequired = field === 'name';
                                        return (
                                            <div key={field} className="mb-3">
                                                <label className="form-label">{FIELD_LABELS[field] || field}{isRequired ? ' *' : ''}</label>
                                                {inputType === 'textarea' ? (
                                                    <textarea
                                                        className="form-control"
                                                        rows={3}
                                                        value={editForm[field] ?? ''}
                                                        onChange={(e) => handleEditFormChange(field, e.target.value)}
                                                        required={isRequired}
                                                    />
                                                ) : (
                                                    <input
                                                        type={inputType}
                                                        className="form-control"
                                                        value={editForm[field] ?? ''}
                                                        onChange={(e) => handleEditFormChange(field, e.target.value)}
                                                        required={isRequired}
                                                    />
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={closeEditModal}>Cancel</button>
                                    <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                        {isLoading ? 'Saving...' : 'Save changes'}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}

            <ToastContainer />
        </div>
    );
}

export default ServiceList;
